import { ModalsContext } from 'app/components/Layouts/Modals';
import React, { useContext } from 'react';
import IconText from '../IconText';


export default function CloseBtn() {

    const { close } = useContext(ModalsContext);

    return (
        <a onClick={e => {
            e.preventDefault();
            close();
        }} className="absolute cursor-pointer right-24px top-0 -translate-y-1/2  bg-red rounded-full flex items-center justify-center px-16px py-12px">
            <IconText className={"text-white font-medium text-16"} icon="close" text='Close' />
        </a>
    );
}
